import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { useCallback } from 'react';

export const useBrandProductGroupResolver = (brandGroups: BrandGroupEntity[]) => {
    const resolveSelectedBrandProductGroupIds = useCallback(
        (selectedBrandGroupIds: string[]): string[] => {
            if (!selectedBrandGroupIds.length) {
                return [];
            }

            const selectedBrandGroupIdsSet = new Set(selectedBrandGroupIds);
            const productGroupIds = brandGroups.flatMap((brandGroup) =>
                selectedBrandGroupIdsSet.has(brandGroup.id) ? brandGroup.productGroupIds : [],
            );

            return [...new Set(productGroupIds)];
        },
        [brandGroups],
    );

    return {
        resolveSelectedBrandProductGroupIds,
    };
};
